import { render, staticRenderFns } from "./SearchPost.vue?vue&type=template&id=6a58c313&scoped=true"
import script from "./SearchPost.vue?vue&type=script&lang=js"
export * from "./SearchPost.vue?vue&type=script&lang=js"
import style0 from "./SearchPost.vue?vue&type=style&index=0&id=6a58c313&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58c313",
  null
  
)

export default component.exports